import {
  playBattlePassClaimSound,
  playBattlePassLevelUpSound,
  playBattlePassXpSound,
} from "../ui-sounds";
import type { BattlePassXpResult } from "./types";

function ensureHost(): HTMLElement {
  let host = document.getElementById("battlePassFxHost");
  if (!host) {
    host = document.createElement("div");
    host.id = "battlePassFxHost";
    host.className = "battlePassFxHost";
    document.body.appendChild(host);
  }
  return host;
}

export function notifyBattlePassXp(result: Partial<BattlePassXpResult> | null | undefined): void {
  if (!result || !result.granted) return;
  playBattlePassXpSound();
  const host = ensureHost();
  const toast = document.createElement("div");
  toast.className = "battlePassXpToast";
  toast.textContent = `+${result.granted} BP XP`;
  host.appendChild(toast);
  window.setTimeout(() => toast.remove(), 1600);
  if ((result.levelsGained || 0) > 0) {
    notifyBattlePassLevelUp(result.level || 1, result.levelsGained || 1);
  }
}

export function notifyBattlePassLevelUp(level: number, gained = 1): void {
  playBattlePassLevelUpSound();
  const host = ensureHost();
  const overlay = document.createElement("div");
  overlay.className = "battlePassLevelUp";
  overlay.innerHTML = `<div class="battlePassLevelUpCard"><span>LEVEL UP</span><strong>${level}</strong>${
    gained > 1 ? `<em>+${gained} levels</em>` : ""
  }</div>`;
  host.appendChild(overlay);
  window.setTimeout(() => overlay.remove(), 2200);
}

export function notifyBattlePassClaim(label: string, imageData?: string | null): void {
  playBattlePassClaimSound();
  const host = ensureHost();
  const card = document.createElement("div");
  card.className = "battlePassClaimToast";
  if (imageData) {
    const img = document.createElement("img");
    img.src = imageData;
    img.alt = "";
    card.appendChild(img);
  }
  const text = document.createElement("span");
  text.textContent = label || "Reward claimed";
  card.appendChild(text);
  host.appendChild(card);
  window.setTimeout(() => card.remove(), 1800);
}
